import { render, staticRenderFns } from "./LockMails.vue?vue&type=template&id=675fd170&scoped=true"
import script from "./LockMails.vue?vue&type=script&lang=js"
export * from "./LockMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675fd170",
  null
  
)

export default component.exports